import React from "react";
import { Box, Chip } from "@mui/material";

/**
 * Single-select filter chip row (controlled). Matches the desktop TodoList
 * behaviour where selecting a filter replaces any previously applied one.
 *
 * @param {{label:string, field:string}[]} items
 * @param {string|null} value    currently selected field
 * @param {(field:string|null)=>void} onChange
 */
export default function Chips({ items = [], value = null, onChange }) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
      {items.map((item) => {
        const selected = value === item.field;
        return (
          <Chip
            key={item.field}
            label={item.label}
            onClick={() => onChange(selected ? null : item.field)}
            variant={selected ? "filled" : "outlined"}
            size="small"
            sx={{
              borderColor: "neutral.clr-200",
              bgcolor: selected ? "primary.clr-50" : "transparent",
              color: selected ? "primary.clr-300" : "neutral.clr-600",
              "& .MuiChip-label": { fontSize: 12 },
            }}
          />
        );
      })}
    </Box>
  );
}
